module.exports = __webpack_public_path__ + "static/2303eeda391561cd7d717b0c94d31bf0997a51f5d23ddf28f282845f66de07ea-bf718aec244352217eb878636d01b377.png";